// Copyright ©️ 2026 eVolve MEP, LLC

import type { StrongOmit } from '@evolvemep/api-ts';
import { useElementSize } from '@mantine/hooks';

import { NumberInputWrapped, type NumberInputWrappedProps } from 'components/Mantine/NumberInputWrapped';
import { isNil } from 'helpers/isNotNil';

import classes from './BendDimensionInput.module.css';
import { StepButton } from './StepButton';

type Props = StrongOmit<NumberInputWrappedProps, `${'left' | 'right'}Section${'' | 'Width' | 'PointerEvents'}`>;

export const BendQuantityStepper = (props: Props) => {
  const { ref: leftSectionRef, width: leftSectionWidth } = useElementSize<HTMLDivElement>();
  const { ref: rightSectionRef, width: rightSectionWidth } = useElementSize<HTMLDivElement>();
  return (
    <NumberInputWrapped
      {...props}
      leftSectionWidth={leftSectionWidth}
      classNames={{ label: classes.label, input: classes.input, error: classes.error }}
      leftSectionPointerEvents="all"
      leftSection={
        <StepButton
          ref={leftSectionRef}
          direction="decrease"
          onClick={() => props.onChange(Math.max(0, (props.value ?? 0) - 1))}
          disabled={isNil(props.value) || props.value <= 0}
        />
      }
      rightSectionWidth={rightSectionWidth}
      rightSectionPointerEvents="all"
      rightSection={
        <StepButton
          ref={rightSectionRef}
          direction="increase"
          onClick={() => props.onChange(Math.min(99, (props.value ?? 0) + 1))}
          disabled={isNil(props.value) || props.value >= 99}
        />
      }
    />
  );
};
